"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPaymentErrorNotification = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const PaymentErrorNotificationType = 'error - Payment method';
function trackPaymentErrorNotification(errorMessage, paymentMethod) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ShowNotification,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            notification_type: PaymentErrorNotificationType,
            notification_message: errorMessage,
            payment_method: paymentMethod,
        },
    });
}
exports.trackPaymentErrorNotification = trackPaymentErrorNotification;
//# sourceMappingURL=trackPaymentErrorNotification.js.map